import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from 'src/app/dialog.component';
import { ImageModuleComponent } from 'src/app/image-module/image-module.component';
import { sessionStorage } from 'src/app/localstorage.service';
import { Location } from '@angular/common';
import { ExpenseModalComponent } from 'src/app/expense/expense-modal/expense-modal.component';
import { BtlExpenseModalComponent } from '../btl-expense-modal/btl-expense-modal.component';


@Component({
  selector: 'app-contractor-meet-detail',
  templateUrl: './contractor-meet-detail.component.html'
})
export class ContractorMeetDetailComponent implements OnInit {
  meetingID: any;
  img_url = ''
  expense_url = '';
  sendData: any = {};
  skLoading: boolean = false;
  btl: any;
  downurl: any = '';
  logined_user_data: any = {};
  constructor(public route: ActivatedRoute,
    public location: Location,
    public rout: Router,
    public toast: ToastrManager,
    public serve: DatabaseService,
    public alert: DialogComponent,
    public dialogs: MatDialog,
    public session: sessionStorage
  ) {
    this.img_url = this.serve.uploadUrl + 'event_file/';
    this.expense_url = this.serve.uploadUrl + 'expense/';
    this.route.params.subscribe(prm => {
      this.meetingID = prm.id;
      this.serve.currentUserID = prm.id
    })
    this.downurl = serve.downloadUrl
    this.logined_user_data = this.session.getSession();
    this.logined_user_data = this.logined_user_data.value;
    this.logined_user_data = this.logined_user_data.data;
    this.getMeetingDetails()
  }

  ngOnInit() {
  }

  tmparray: any = [];

  getMeetingDetails() {

    this.sendData = {
      id: this.meetingID
    }
    this.skLoading = true;
    this.serve.post_rqst(this.sendData, "Event/eventDetail").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.btl = result['result'];
        this.btl.expense_sharing_amount_percentage = (parseInt(this.btl.total_budget) * parseInt(this.btl.expense_sharing_amount)) / 100
        this.skLoading = false;
      } else {
        this.toast.errorToastr(result['statusMsg']);
        this.skLoading = false;
      }
    }, err => {
      this.toast.errorToastr('Something went wrong');
    })
  }


  goToImage(image) {
    const dialogRef = this.dialogs.open(ImageModuleComponent, {
      panelClass: 'Image-modal',
      data: {
        'image': image,
        'type': 'base64'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  getEventDetailExcel() {
    this.skLoading = true;
    this.sendData = {
      id: this.meetingID
    }
    this.serve.post_rqst(this.sendData, "Excel/eventDetail").subscribe((result) => {
      if (result['msg'] == true) {
        window.open(this.downurl + result['filename'])
        this.getMeetingDetails();
      }
    });
  }



  back(): void {
    this.location.back()
  }

  openUTRModal(id) {
    const dialogRef = this.dialogs.open(ExpenseModalComponent, {
      width: '400px',
      data: {
        id,
        from: 'btlDetail',
        approved_amount: this.btl.expense_amount || '',
        expense_id: this.btl.expense_id || '',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getMeetingDetails();

    });
  }

  openExpenseModal(eventId) {
    const dialogRef = this.dialogs.open(BtlExpenseModalComponent, {
      width: '500px',
      panelClass: 'cs-modal',
      data: {
        'event_id': eventId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.getMeetingDetails();
      }
    });
  }

}
